"use client";

import { Box } from "@chakra-ui/react";
import YouTube from "react-youtube";

type Props = {
  src: string;
};

const WelcomeVideo: React.FC<Props> = ({ src }) => (
  <Box maxWidth={800} borderRadius={10} overflow="hidden">
    <YouTube videoId={src} />
  </Box>
);

export default WelcomeVideo;
